const mapWeekday = weekday => {
  return {
    monday: "segunda",
    tuesday: "terça",
    wednesday: "quarta",
    thursday: "quinta",
    friday: "sexta",
    saturday: "sabado",
    sunday: "domingo"
  }[weekday];
};

export default mapWeekday;
